import { ajax } from "@/plugins/ajax";
import { QuerySelector } from "ag-grid-community";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Credits/api/SubsidiaryAccountsQuery").then(r => {
        // commit("setList", r.data.data);
        return r.data.data;
      });
    },
    fetchSubsidiary({ commit, dispatch } , id ) {
      return ajax.get(`Credits/api/AccountsQuery/get_all-subsidiary-and-detail-accounts`).then(r => {
        commit("setList", r.data);
        return r.data;
      });
    },
    fetchSubsidiaryByname({ commit, dispatch } , {id , name}) {
      return ajax.get(`Credits/api/AccountsQuery/get_all-subsidiary-and-detail-accounts/` +'?name=' + `${name}`,          

    ).then(r => {
        commit("setList", r.data);
        return r.data;
      });
    },

    create({ commit, dispatch }, model) {
      return ajax.post("Credits/api/SubsidiaryAccounts", model).then(() => {
        
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Credits/api/SubsidiaryAccounts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Credits/api/SubsidiaryAccounts", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
